var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 578.29,
    height: 444.46,
    viewBox: "0 0 578.29 444.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Analogous_2);\n      }\n\n      .cls-2 {\n        fill: url(#Analogous_2-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Analogous_2",
    "data-name": "Analogous 2",
    y1: 222.04,
    x2: 578.29,
    y2: 222.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0065b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009c3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Analogous_2-2",
    x1: 220.99,
    y1: 402.15,
    x2: 513.2,
    y2: 402.15,
    xlinkHref: "#Analogous_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.35,444.09,0,429.46,247.94,0h17.32L410.92,251.43a10,10,0,1,1-17.32,10L256.6,25l-227,393.24,536-149.47A10,10,0,1,1,571,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.55,444.46H231a10,10,0,0,1,0-20H487.18l-29.71-49.59a10,10,0,0,1,17.3-10l38.43,64.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f41ea7d84683be6a9878b9290883ac58.svg";
export { ForwardRef as ReactComponent };